module.exports = __webpack_public_path__ + "images/ranking-events-visibility-gains-01c288b8.svg";